import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PinEndIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pin_end"}/>
}
